import React from 'react';
import { createRoot } from 'react-dom/client';
import Container from '../../src/news_search_react/components/container/container';
import { ContextProvider } from '../../src/news_search_react/context/news_search.context';
import { BrowserRouter } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import CustomReactRouter7Adapter from '../../src/utilities/custom_react_router_7_adapter';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('news-search-react-app');
  if (!container) return;

  const root = createRoot(container);

  root.render(
    <DevexHighOrderComponent>
      <BrowserRouter>
        <QueryParamProvider adapter={CustomReactRouter7Adapter}>
          <ContextProvider
            isSignedIn={JSON.parse(container.dataset.isSignedIn)}
            userId={container.dataset.userId !== '0' ? JSON.parse(container.dataset.userId) : null}
            trendingNewsTopics={JSON.parse(container.dataset.trendingNewsTopics)}
          >
            <Container />
          </ContextProvider>
        </QueryParamProvider>
      </BrowserRouter>
    </DevexHighOrderComponent>
  );
});
